import React from "react";
import { useHistory } from "react-router-dom";
import routeNames from "./../../utilities/server/routeNames";
import { StyledContainer, StyledButton } from "./styles";
import Newsletter from "./../../components/Newsletter";
import Layout from "./../../global/Layout";
// import { useIsMobile } from "../../makealist/api/hooks/use-is-mobile";
import { mixFontObj } from "../../makealist/styles/mixins";
import { FormButton } from "../../makealist/styles/fonts";
import { StyledClosedButton } from "../../makealist/routes/common/styles";
import SVGicon from "../../makealist/assets/svgs"; // @TODO Convert
// import { toggleClientRoot } from "./../toggleClientRoute";

const skipStyles = {
  position: "absolute",
  top: "20px",
  right: "20px",
};

const CollectData = ({ history, location, context, clientContext }) => {
  const isClient = typeof window === "object";
  let { settings } = context.data;
  let { isMobile } = clientContext;

  if (!location || !location.state || !location.state.isQueueFull) {
    history.push(routeNames.home);
  }

  const { isQueueFull } = location.state;

  const onCloseClickHandler = () =>
    history.push(routeNames.viewposter, {
      isDataCollectionSkipped: true,
      isQueueFull,
    });

  // history.push(routeNames.createlist, location.state);

  const onSkipHandler = () =>
    history.push(routeNames.viewposter, {
      isDataCollectionSkipped: true,
      isQueueFull,
    });

  return (
    <StyledContainer isMobile={isMobile}>
      <StyledClosedButton
        onClick={onCloseClickHandler}
        isMobile={isMobile}
        customstyles={skipStyles}
      >
        <SVGicon iconName="timesWhite" />
      </StyledClosedButton>
      <Newsletter
        submitText="VIEW YOUR LIST"
        submitStyles={{
          ...mixFontObj(FormButton),
          position: isMobile ? "fixed" : "relative",
          width: isMobile ? "335px" : "238px",
          height: isMobile ? "50px" : "50px",
          border: "none",
          left: isMobile ? "50%" : "50%",
          bottom: isMobile ? "20px" : "",
          transform: isMobile
            ? "translate(-50%, 0)"
            : "translate3d(-50%, -50%, 0)",
          "transform-origin": "center",
          "margin-top": isMobile ? "60px" : "80px",
          background: "black",
        }}
        headerStyles={{ "font-size": "12px" }}
        headerText="We just need a few details and your list will be ready to share with the world."
        dataLabel="SIGN UP"
        redirectTo={() => {
          history.push(routeNames.viewposter, {
            isDataCollected: true,
            isQueueFull,
          });
        }}
        containerStyles={{
          "text-align": "center",
        }}
        clientContext={clientContext}
        context={context}
      />
      <StyledButton onClick={onSkipHandler}>
        {settings.signupPopup.form.already_signed_up}
      </StyledButton>
    </StyledContainer>
  );
};

export default (props) => {
  const isClient = typeof window === "object";
  const history = useHistory();
  let { context, clientContext } = props;
  let { isMobile } = clientContext;
  // console.log("props collect data", props);
  return (
    <Layout
      context={context}
      clientContext={clientContext}
      newsletter={{
        showNewsletter: false,
        checkCookie: true,
        delayShowNewsletter: 5000,
        checkCookieCount: 2,
      }}
      isHomepage={false}
    >
      <CollectData
        isMobile={isMobile}
        history={history}
        clientContext={clientContext}
        context={context}
        {...props}
      />
    </Layout>
  );
};
